import {
  LogoFileExtntionRequest,
  LogoFileExtntionResponse,
  RestaurantFormData,
} from "../../views/Profile/AddRestaurant";
import { apiSlice } from "../apiSlice";
const API_BASE_DOMAIN = process.env.REACT_APP_API_BASE_DOMAIN_PROD;

export interface RestaurantImageUpdateRequest {
  imageRef: string;
  restId?: string;
  oldImgUrl: string;
}

export interface SalesWalletByRestaurantId {
  cashSales: number;
  creditCardSales: number;
  myEarnings: number;
  commissionsToCart: number;
  payableToPlatform: number;
  currency: string;
  createdAt: {
    _seconds: number;
    _nanoseconds: number;
  };
  updatedAt: {
    _seconds: number;
    _nanoseconds: number;
  };
}

export interface restaurantBankDataUpdateRequest {
  restaurantId: string;
  accountName: string;
  accountNumber: string;
  bankName: string;
  branchName: string;
  swiftCode: string;
}

export const restaurantService = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getRestaurantsByOwnerIdCallable: builder.query({
      query: (ownerId) =>
        `https://adminhttps-getadminidforuserid${API_BASE_DOMAIN}?userId=${ownerId}`,
      providesTags: ["Restaurant"],
    }),

    getRestaurantsByOwnerId: builder.query({
      query: (ownerId) =>
        `https://adminhttps-getrestaurantsbyownerid${API_BASE_DOMAIN}?ownerId=${ownerId}`,
      providesTags: ["Restaurant"],
    }),

    createRestaurantHttps: builder.mutation<string, RestaurantFormData>({
      query: (data) => ({
        url: `https://adminhttps-createrestaurant${API_BASE_DOMAIN}/`,
        method: "POST",
        body: data,
        responseHandler: (response) => response.json(),
      }),
    }),

    UploadRestaurantLogoFileExtntionHttps: builder.mutation<
      LogoFileExtntionResponse,
      LogoFileExtntionRequest
    >({
      query: (data) => ({
        url: `https://adminhttps-getrestaurantlogouploadurl${API_BASE_DOMAIN}/`,
        method: "POST",
        body: data,
      }),
    }),

    updateRestaurantHttps: builder.mutation<
      string,
      { restaurantId: string; data: any }
    >({
      query: ({ restaurantId, data }) => ({
        url: `https://adminhttps-updaterestaurant${API_BASE_DOMAIN}?restaurantId=${restaurantId}`,
        method: "PUT",
        body: data,
      }),
    }),

    deleteRestaurantHttps: builder.mutation<
      string,
      { restaurantId: string; data: [] }
    >({
      query: ({ restaurantId, data }) => ({
        url: `https://adminhttps-deleterestaurant${API_BASE_DOMAIN}?restaurantId=${restaurantId}`,
        method: "PUT",
        body: data,
      }),
    }),

    getRestaurantTypes: builder.query({
      query: () =>
        `https://adminhttps-getrestauranttypeslist${API_BASE_DOMAIN}`,
    }),

    getRestaurantCategories: builder.query({
      query: () =>
        `https://adminhttps-getcategorylistforrestaurant${API_BASE_DOMAIN}`,
    }),

    updateRestaurantImage: builder.mutation<any, RestaurantImageUpdateRequest>({
      query: (data) => ({
        url: `https://adminhttps-updaterestaurantimage${API_BASE_DOMAIN}/`,
        method: "POST",
        body: data,
        responseHandler: (response) => response.text(),
      }),
    }),
    getRestaurantDetailsById: builder.query({
      query: (restaurantId) =>
        `https://adminhttps-getrestaurantsbyrestaurantid${API_BASE_DOMAIN}/?restaurantId=${restaurantId}`,
    }),
    getCartsForRestaurantByRestaurantId: builder.query({
      query: (restaurantId) =>
        `https://adminhttps-getcartlistbyrestaurantid${API_BASE_DOMAIN}/?restId=${restaurantId}`,
    }),
    getCartInventoryForRestaurant: builder.query({
      query: ({
        restaurantId,
        cartId,
        inventoryId,
      }: {
        restaurantId: string;
        cartId: string;
        inventoryId: string;
      }) =>
        `https://adminhttps-getcartinventorybyrestaurantid${API_BASE_DOMAIN}?cartId=${cartId}&restId=${restaurantId}&InventId=${inventoryId}`,
    }),
    getRestaurantProperties: builder.query({
      query: () =>
        `https://adminhttps-getrestaurantpropertylist${API_BASE_DOMAIN}/`,
    }),
    getPendingCartRequestByRestaurantId: builder.query({
      query: (restaurantId) =>
        `https://adminhttps-getpendingcartrequestbyrestaurantid${API_BASE_DOMAIN}?restId=${restaurantId}`,
    }),
    getSalesWalletByRestaurantId: builder.query<
      SalesWalletByRestaurantId,
      string
    >({
      query: (restaurantId) =>
        `https://adminhttps-getsaleswalletbyrestaurantid${API_BASE_DOMAIN}?restaurantId=${restaurantId}`,
    }),
    updaterestaurantBankData: builder.mutation<
      any,
      restaurantBankDataUpdateRequest
    >({
      query: (data) => ({
        url: `https://adminhttps-addrestaurantbankdetails${API_BASE_DOMAIN}/`,
        method: "POST",
        body: data,
        responseHandler: (response) => response.text(),
      }),
    }),

    getRestaurantFlowTypes: builder.query({
      query: () => `https://adminhttps-getflowtypeslist${API_BASE_DOMAIN}`,
    }),
    getCartTransactionsByCartId: builder.query({
      query: ({ cartId, date }: { cartId: string; date?: string }) =>
        `https://adminhttps-getdailycartsales${API_BASE_DOMAIN}/?cartId=${cartId}&date=${date}`,
    }),
    getPurchaseWalletByCartId: builder.query({
      query: (cartId) =>
        `https://adminhttps-getpurchasewalletforcartperson${API_BASE_DOMAIN}/?cartId=${cartId}`,
    }),
    settleCartPayment: builder.mutation({
      query: ({ cartId, amount, restaurantId }) => ({
        url: `https://adminhttps-settlecartpayabletoplatform${API_BASE_DOMAIN}/`,
        method: "POST",
        body: {
          cartId,
          amount,
          restaurantId,
        },
      }),
    }),
  }),
});

export const {
  useLazyGetRestaurantsByOwnerIdQuery,
  useCreateRestaurantHttpsMutation,
  useUpdateRestaurantHttpsMutation,
  useDeleteRestaurantHttpsMutation,
  useUploadRestaurantLogoFileExtntionHttpsMutation,
  useGetRestaurantTypesQuery,
  useGetRestaurantCategoriesQuery,
  useLazyGetRestaurantCategoriesQuery,
  useUpdateRestaurantImageMutation,
  useGetRestaurantDetailsByIdQuery,
  useLazyGetRestaurantDetailsByIdQuery,
  useGetCartsForRestaurantByRestaurantIdQuery,
  useLazyGetCartsForRestaurantByRestaurantIdQuery,
  useGetCartInventoryForRestaurantQuery,
  useLazyGetCartInventoryForRestaurantQuery,
  useGetRestaurantPropertiesQuery,
  useGetPendingCartRequestByRestaurantIdQuery,
  useLazyGetPendingCartRequestByRestaurantIdQuery,
  useGetSalesWalletByRestaurantIdQuery,
  useLazyGetSalesWalletByRestaurantIdQuery,
  useUpdaterestaurantBankDataMutation,
  useGetRestaurantFlowTypesQuery,
  useLazyGetRestaurantFlowTypesQuery,
  useGetCartTransactionsByCartIdQuery,
  useLazyGetCartTransactionsByCartIdQuery,
  useGetPurchaseWalletByCartIdQuery,
  useLazyGetPurchaseWalletByCartIdQuery,
  useSettleCartPaymentMutation,
} = restaurantService;
